import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class ConfigurationQueryService {
  private CREATE_PRODUCT: any;
  private GET_ALL_PRODUCTs: any;
  private DELETE_PRODUCT: any;
  private UPDATE_PRODUCT: any;

  private CREATE_MARKET: any;
  private GET_ALL_MARKET: any;
  private DELETE_MARKET: any;
  private UPDATE_MARKET: any;

  private GET_MARKET_BY_NAME: any;
  private GET_FIRM_BY_NAME: any;
  private GET_OFFICE_BY_NAME: any;

  private CREATE_FIRM: any;
  private GET_ALL_FIRM: any;
  private DELETE_FIRM: any;
  private UPDATE_FIRM: any;

  private CREATE_OFFICE: any;
  private GET_ALL_OFFICE: any;
  private GET_ALL_STATUS: any;
  private DELETE_OFFICE: any;
  private UPDATE_OFFICE: any;
  private UPDATE_STATUSES: any;


  private CHECK_MARKETS_MULTI_FIRMS: any;
  private CREATE_MARKETS_MULTI_FIRMS: any;
  private UPDATE_MARKETS_MULTI_FIRMS: any;
  private DELETE_MARKETS_MULTI_FIRMS: any;

  private CHECK_FIRMS_MULTI_OFFICES: any;
  private CREATE_FIRMS_MULTI_OFFICES: any;
  private UPDATE_FIRMS_MULTI_OFFICES: any;
  private DELETE_FIRMS_MULTI_OFFICES: any;

  private CREATE_COUPON: any;
  private GET_ALL_COUPONS: any;
  private DELETE_COUPON: any;
  private UPDATE_COUPON: any;

  private GET_ALL_ROLES: any;
  private CREATE_ROLE: any;
  private CREATE_STATUS: any;
  private DELETE_ROLE: any;
  private UPDATE_ROLE: any;

  private GET_FIRM_OFFICE: any;
  private GET_MARKET_FIRM: any;

  public LIST_ORDER_BY_MARKETS_FIRMS_OFFICES: any;

  public GET_MARKET_ALL: any;
  public GET_ORDER_BY_MARKET: any;

  private GET_ALL_MARKET_LIMIT: any;
  public GET_MAIL_TYPE: any;
  public ADD_MAIL_TYPE: any;
  public UPDATE_EMAIL_TYPE: any;

  public GET_MAIL_TYPE_CONTENT: any;
  public ADD_MAIL_TYPE_CONTENT: any;
  public GET_MAIL_TYPE_DROP_DOWN: any;
  public UPDATE_EMAIL_TYPE_CONTENT: any;

  public ADD_BREAKING_NEW: any;
  public GET_BREAKING_NEWS: any;
  public UPDATE_BREAKING_NEW: any;
  public UPDATE_LOGO_URL: any;

  constructor(public apollo: Apollo) {
    this.CREATE_PRODUCT = gql`
        mutation createProduct($input:CreateProductInput!) {
            createProduct(input:$input) {
                 product {
                 productId
                 productName
                 productPrice
                 productDesc1
                 sku
                 isDeletedYn
                 createdAt
                 updatedAt
                }
              }
            }
      `;

    this.GET_ALL_PRODUCTs = gql`
        query Product($offset:Int,$limit:Int){
         allProducts(filter:{isDeletedYn:{equalTo: false}},offset:$offset,first:$limit){
          nodes{
            productId
            productName
            productPrice
            productDesc1
            sku
            isDeletedYn
            createdAt
            updatedAt
          }
          totalCount
            }
          }
            `;

    this.UPDATE_PRODUCT = gql`
            mutation updateProduct($input:UpdateProductByProductIdInput!) {
                updateProductByProductId(input:$input) {
                     product{
                     productId
                     productName
                     productPrice
                     productDesc1
                     sku
                     isDeletedYn
                     createdAt
                     updatedAt
                    }
                  }
                }
            `;

    this.DELETE_PRODUCT = gql`
        mutation updateIsDeletedYnForProduct($input:UpdateProductByProductIdInput!) {
            updateProductByProductId(input:$input) {
                 product{
                 productId
                 productName
                 productPrice
                 productDesc1
                 sku
                 isDeletedYn
                 createdAt
                 updatedAt
                }
              }
            }
        `;

    this.CREATE_MARKET = gql`
        mutation createMarkets($input:CreateMarketInput!) {
            createMarket(input:$input) {
                 market {
                     marketId
                  marketName
                  isDeletedYn
                  createdat
                  updatedat
                }
              }
            }
      `;

    this.GET_ALL_MARKET = gql`
    query Markets {
      allMarkets(filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          marketId
          marketName
          marketsMultiFirmsByMarketId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              firmId
              marketsMultiFirmsId
              firmByFirmId {
                firmsName
                logoUrl
                firmsMultiOfficesByFirmId(filter: {isDeletedYn: {equalTo: false}}) {
                  nodes {
                    officeId
                    marketId
                    firmId
                    firmsMultiOfficesId
                    officeByOfficeId {
                      officesName
                    }
                  }
                }
              }
            }
          }
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }
        `;

    this.UPDATE_MARKET = gql`
        mutation updateMarkets($input:UpdateMarketByMarketIdInput!) {
            updateMarketByMarketId(input:$input) {
                 market{
                    marketId
                  marketName
                  isDeletedYn
                  createdat
                  updatedat
                }
              }
            }
            `;

    this.DELETE_MARKET = gql`
        mutation updateIsDeletedYnForMarkets($input:UpdateMarketByMarketIdInput!) {
            updateMarketByMarketId(input:$input) {
                 market{
                        marketId
                        marketName
                 isDeletedYn
                 createdat
                 updatedat
                }
              }
            }
        `;

    this.CREATE_FIRM = gql`
        mutation createFirms($input:CreateFirmInput!) {
          createFirm(input:$input) {
               firm {
                firmId
                firmsName
                logoUrl
                isDeletedYn
                createdat
                updatedat
              }
            }
          }
      `;

    this.CREATE_OFFICE = gql`
      mutation createOffices($input:CreateOfficeInput!) {
        createOffice(input:$input) {
             office {
              officeId
              officesName
              isDeletedYn
              createdat
              updatedat
            }
          }
        }
      `;

    this.GET_ALL_FIRM = gql`
    query marketBasedFirms($offset: Int, $limit: Int, $marketId: Int) {
      allMarketsMultiFirms(filter: {isDeletedYn: {equalTo: false}, marketId: {equalTo: $marketId}}, offset: $offset, first: $limit) {
        nodes {
          firmId
          marketsMultiFirmsId
          marketId
          firmByFirmId {
            firmsName
            logoUrl
            firmsMultiOfficesByFirmId(filter: {isDeletedYn: {equalTo: false}}) {
              nodes {
                officeId
                firmsMultiOfficesId
                officeByOfficeId {
                  officesName
                }
              }
            }
          }
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }
        `;

    this.DELETE_FIRM = gql`
        mutation updateIsDeletedYnForFirms($input:UpdateFirmByFirmIdInput!) {
          updateFirmByFirmId(input:$input) {
               firm{
                firmId
                firmsName
               isDeletedYn
               createdat
               updatedat
              }
            }
          }
        `;

    this.UPDATE_FIRM = gql`
        mutation updateFirms($input:UpdateFirmByFirmIdInput!) {
          updateFirmByFirmId(input:$input) {
               firm{
                  firmId
                firmsName
                isDeletedYn
                createdat
                updatedat
              }
            }
          }
            `;

    this.GET_ALL_OFFICE = gql`
    query firmsBasedoffices($offset: Int, $limit: Int, $marketId: Int, $firmId:Int) {
      allFirmsMultiOffices(filter: {isDeletedYn: {equalTo: false}, marketId: {equalTo: $marketId},firmId: {equalTo: $firmId}}, offset: $offset, first: $limit) {
        nodes {
          firmsMultiOfficesId
          firmId
          officeId
          officeByOfficeId{
            officesName
          }
          marketId
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }
        `;

    this.GET_ALL_STATUS = gql`
    query allStatuses{
      allStatuses(filter: {availableStatus: {equalTo: true}}){
        nodes{
          nodeId
          statusId
          statusName
          createat
          availableStatus
          displayStatus
          statusColor
        }totalCount
      }
    }
    `;

    this.DELETE_OFFICE = gql`
        mutation updateIsDeletedYnForOffices($input:UpdateOfficeByOfficeIdInput!) {
          updateOfficeByOfficeId(input:$input) {
               office{
                officeId
                officesName
               isDeletedYn
               createdat
               updatedat
              }
            }
          }
        `;

    this.UPDATE_OFFICE = gql`
          mutation updateOffices($input:UpdateOfficeByOfficeIdInput!) {
            updateOfficeByOfficeId(input:$input) {
                 office{
                  officeId
                  officesName
                  isDeletedYn
                  createdat
                  updatedat
                }
              }
            }
            `;

    this.UPDATE_STATUSES = gql`
            mutation updateStatus($input: UpdateStatusByStatusIdInput!) {
              updateStatusByStatusId(input: $input) {
                status {
                  nodeId
                  statusId
                  statusName
                  createat
                  availableStatus
                  displayStatus
                  statusColor
                }
              }
            }`;

    this.CREATE_MARKETS_MULTI_FIRMS = gql`mutation createMarketsMultiFirms($input:CreateMarketsMultiFirmInput!) {
              createMarketsMultiFirm(input:$input) {
                   marketsMultiFirm {
                    marketsMultiFirmsId
                    marketId
                    firmId
                    isDeletedYn
                    createdat
                    updatedat
                  }
                }
              }`;

    this.UPDATE_MARKETS_MULTI_FIRMS = gql`mutation updateMarketsMultiFirms($input:UpdateMarketsMultiFirmByMarketsMultiFirmsIdInput!) {
      updateMarketsMultiFirmByMarketsMultiFirmsId(input:$input) {
           marketsMultiFirm{
           marketId
           firmId
           firmsName
           firmByFirmId{
             logoUrl
            }
           isDeletedYn
           createdat
           updatedat
          }
        }
      }`;

    this.CREATE_FIRMS_MULTI_OFFICES = gql`mutation createFirmsMultiOffices($input:CreateFirmsMultiOfficeInput!) {
                createFirmsMultiOffice(input:$input) {
                     firmsMultiOffice {
                      firmsMultiOfficesId
                      firmId
                      officeId
                      isDeletedYn
                      createdat
                      updatedat
                    }
                  }
                }`;

    this.UPDATE_FIRMS_MULTI_OFFICES = gql`mutation updateFirmsMultiOffices($input:UpdateFirmsMultiOfficeByFirmsMultiOfficesIdInput!) {
      updateFirmsMultiOfficeByFirmsMultiOfficesId(input:$input) {
           firmsMultiOffice{
           officeId
           firmId
            officesName
           isDeletedYn
           createdat
           updatedat
            marketId
          }
        }
      }`;

    this.DELETE_MARKETS_MULTI_FIRMS = gql`mutation updateIsDeletedYnForMarketsMultiFirm($input:UpdateMarketsMultiFirmByMarketsMultiFirmsIdInput!) {
                  updateMarketsMultiFirmByMarketsMultiFirmsId(input:$input) {
                       marketsMultiFirm{
                       marketsMultiFirmsId
                       marketId
                       firmId
                       isDeletedYn
                       createdat
                       updatedat
                      }
                    }
                  }`;

    this.DELETE_FIRMS_MULTI_OFFICES = gql`mutation updateIsDeletedYnForFirmsMultiOffices($input:UpdateFirmsMultiOfficeByFirmsMultiOfficesIdInput!) {
              updateFirmsMultiOfficeByFirmsMultiOfficesId(input:$input) {
                  firmsMultiOffice{
                  firmsMultiOfficesId
                  officeId
                  firmId
                  isDeletedYn
                  createdat
                  updatedat
                 }
               }
             }`;

    this.CREATE_COUPON = gql`
      mutation createCoupons($input:CreateCouponInput!) {
      createCoupon(input:$input) {
           coupon {
               couponId
            couponCode
            couponDesc
            couponAmount
            usageLimit
            totalLimit
            expireDate
            isDeletedYn
            createdat
            updatedat
          }
        }
      }
      `;

    this.GET_ALL_COUPONS = gql`
    query Coupons($offset: Int, $limit: Int) {
      allCoupons(filter: {isDeletedYn: {equalTo: false}}, offset: $offset, first: $limit, orderBy: COUPON_ID_DESC) {
        nodes {
          couponId
          couponCode
          couponDesc
          couponAmount
          usageLimit
          totalLimit
          expireDate
          usageLimit
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }`;

    this.DELETE_COUPON = gql`
            mutation updateIsDeletedYnForCoupons($input:UpdateCouponByCouponIdInput!) {
              updateCouponByCouponId(input:$input) {
                   coupon{
                    couponId
                    couponCode
                    couponDesc
                    couponAmount
                    usageLimit
                    totalLimit
                    expireDate
                   isDeletedYn
                   createdat
                   updatedat
                  }
                }
              }
        `;

    this.UPDATE_COUPON = gql`
                mutation updateCoupons($input:UpdateCouponByCouponIdInput!) {
                  updateCouponByCouponId(input:$input) {
                       coupon{
                          couponId
                        couponCode
                        couponDesc
                        couponAmount
                        usageLimit
                        totalLimit
                        expireDate
                        isDeletedYn
                        createdat
                        updatedat
                      }
                    }
                  }
            `;

    this.GET_ALL_ROLES = gql`
    query ($limit: Int, $offset: Int) {
      allRoles(filter: {isDeletedYn: {equalTo: false}, roleDiv: {equalTo: true}}, first: $limit, offset: $offset) {
        nodes {
          roleId
          roleDiv
          roleName
          roleDescription
          isDeletedYn
        }
        totalCount
      }
    }`;

    this.CREATE_ROLE = gql`
            mutation createRoles($input: CreateRoleInput!){
              createRole(input: $input){
                role{
                  roleId
                  roleName
                  roleDescription
                  roleDiv
                }
              }
            }
      `;

    this.CREATE_STATUS = gql`mutation createStatus($input: CreateStatusInput!) {
        createStatus(input: $input) {
          status {
            nodeId
            statusId
            statusName
            createat
            availableStatus
            displayStatus
            statusColor
          }
        }
      }`;
    this.DELETE_ROLE = gql`
      mutation updateIsDeletedYnForRole($input:UpdateRoleByRoleIdInput!) {
        updateRoleByRoleId(input:$input) {
             role{
              roleId
              roleName
              roleDescription
              roleDiv
              isDeletedYn
            }
          }
        }
        `;

    this.UPDATE_ROLE = gql`
        mutation updateRoles($input:UpdateRoleByRoleIdInput!) {
          updateRoleByRoleId(input:$input) {
               role{
                roleId
                roleName
                roleDescription
                roleDiv
                isDeletedYn
              }
            }
          }
            `;

    this.GET_MARKET_FIRM = gql`
    query marketBasedFirms($marketId:Int) {
      allMarketsMultiFirms(filter: {isDeletedYn: {equalTo: false},marketId: {equalTo: $marketId}}) {
            nodes {
              firmId
              marketsMultiFirmsId
              firmByFirmId {
                firmsName
              }
            }
          }
    }
            `;

    this.GET_FIRM_OFFICE = gql`
    query firmsBasedoffices($firmId: Int, $marketId: Int) {
      allFirmsMultiOffices(filter: {isDeletedYn: {equalTo: false}, firmId: {equalTo: $firmId}, marketId: {equalTo: $marketId}}) {
        nodes {
          firmId
          marketId
          firmsMultiOfficesId
          officeId
          officeByOfficeId {
            officesName
          }
        }
      }
    }`;

    this.CHECK_MARKETS_MULTI_FIRMS = gql`
            query marketBasedFirmsCheck($marketId:Int,$firmId:Int) {
              allMarketsMultiFirms(filter: {isDeletedYn: {equalTo: false},marketId: {equalTo: $marketId},firmId: {equalTo: $firmId}}) {
                    nodes {
                      marketsMultiFirmsId
                    }
                  }
            }
            `;

    this.CHECK_FIRMS_MULTI_OFFICES = gql`
            query firmsBasedofficesCheck($marketId:Int,$firmId:Int,$officeId:Int) {
              allFirmsMultiOffices(filter: {isDeletedYn: {equalTo: false},firmId: {equalTo: $firmId},officeId: {equalTo: $officeId},marketId: {equalTo: $marketId}}) {
                    nodes {
                      firmsMultiOfficesId
                    }
                  }
            }
            `;

    this.LIST_ORDER_BY_MARKETS_FIRMS_OFFICES = gql`
    query listOrderByMarkets($marketId: Int, $firmId: Int, $officeId: Int) {
      allOrders(filter: {marketId: {equalTo: $marketId}, firmId: {equalTo: $firmId}, officeId: {equalTo: $officeId}}) {
        nodes {
          id
          statusId
          inspectionReportsSrcByOrderId{
            id
            insReportId
            scheduleRequestByScheduleRequestId{
              id
              orderId
            }
          }
        }
        totalCount
      }
    }`;

    this.GET_MARKET_ALL = gql`
    query getAllMarkets {
      allMarkets(filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          marketId
          marketName
        }
      }
    }`;

    this.GET_ORDER_BY_MARKET = gql`
    query listOrderByMarkets($marketId: Int) {
      allOrders(filter: {marketId: {equalTo: $marketId}}) {
        nodes {
          id
          statusId
          marketId
          inspectionReportsSrcByOrderId {
            id
            insReportId
            scheduleRequestByScheduleRequestId {
              id
              orderId
            }
          }
        }
        totalCount
      }
    }`;

    this.GET_MARKET_BY_NAME = gql`
    query getMarketByName($marketName: String) {
      allMarkets(filter: {isDeletedYn: {equalTo: false},marketName: {likeInsensitive: $marketName}}) {
        nodes {
          marketId
          marketName
          isDeletedYn
        }
        totalCount
      }
    }
    `;

    this.GET_FIRM_BY_NAME = gql`
    query getFirmByName($firmsName: String) {
      allFirms(filter: {isDeletedYn: {equalTo: false},firmsName: {likeInsensitive: $firmsName}}) {
        nodes {
          firmId
          firmsName
          logoUrl
          isDeletedYn
        }
        totalCount
      }
    }`;

    this.GET_OFFICE_BY_NAME = gql`
    query getOfficeByName($officesName: String) {
      allOffices(filter: {isDeletedYn: {equalTo: false},officesName: {likeInsensitive: $officesName}}) {
        nodes {
          officeId
          officesName
          isDeletedYn
        }
        totalCount
      }
    }`;


    this.GET_ALL_MARKET_LIMIT = gql`
    query Markets($offset: Int, $limit: Int) {
      allMarkets(offset: $offset, first: $limit, filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          marketId
          marketName
          marketsMultiFirmsByMarketId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              firmId
              marketsMultiFirmsId
              firmByFirmId {
                firmsName
                firmsMultiOfficesByFirmId(filter: {isDeletedYn: {equalTo: false}}) {
                  nodes {
                    officeId
                    marketId
                    firmId
                    firmsMultiOfficesId
                    officeByOfficeId {
                      officesName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`;

    this.GET_MAIL_TYPE = gql`
    query listEmailType($limit: Int, $offset: Int){
      allEmailTypes(filter: { isDeletedYn: { equalTo: false } }, first: $limit, offset: $offset) {
        nodes {
          emailTypeId
          emailTypeDesc
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }
    `;

    this.ADD_MAIL_TYPE = gql`mutation createEmailType($input:CreateEmailTypeInput!) {
          createEmailType(input:$input) {
               emailType {
                emailTypeId
                emailTypeDesc
                isDeletedYn
                createdat
                updatedat
              }
            }
          }`;

    this.UPDATE_EMAIL_TYPE = gql`
          mutation updateEmailType($input:UpdateEmailTypeByEmailTypeIdInput!) {
            updateEmailTypeByEmailTypeId(input:$input) {
                 emailType{
                  emailTypeId
                  emailTypeDesc
                  isDeletedYn
                  createdat
                  updatedat
                }
              }
            }`;

    this.GET_MAIL_TYPE_CONTENT = gql`
            query EmailTypeContent($limit: Int, $offset: Int) {
              allEmailTypeContents(filter: {isDeletedYn: {equalTo: false}}, first: $limit, offset: $offset) {
                nodes {
                  emailTypeContentId
                  emailTypeId
                  emailTypeByEmailTypeId {
                    emailTypeId
                    emailTypeDesc
                  }
                  emailContent
                  isDeletedYn
                  createdAt
                  updatedAt
                }
                totalCount
              }
            }

        `;

    this.ADD_MAIL_TYPE_CONTENT = gql`mutation createEmailTypeContent($input:CreateEmailTypeContentInput!) {
          createEmailTypeContent(input:$input) {
               emailTypeContent {
                   emailTypeContentId
                emailTypeId
                emailContent
                isDeletedYn
                createdAt
                updatedAt
              }
            }
          } `;

    this.GET_MAIL_TYPE_DROP_DOWN = gql`
          query listEmailType {
            allEmailTypes(filter: {isDeletedYn: {equalTo: false}}) {
              nodes {
                emailTypeId
                emailTypeDesc
                isDeletedYn
                createdat
                updatedat
              }
              totalCount
            }
          }

        `;

    this.UPDATE_EMAIL_TYPE_CONTENT = gql`
        mutation updateEmailTypeContent($input:UpdateEmailTypeContentByEmailTypeContentIdInput!) {
          updateEmailTypeContentByEmailTypeContentId(input:$input) {
               emailTypeContent{
                  emailTypeContentId
                emailTypeId
                emailTypeByEmailTypeId{
                  emailTypeId
                  emailTypeDesc
                }
                emailContent
                isDeletedYn
                createdAt
                updatedAt
              }
            }
          }`;

    this.ADD_BREAKING_NEW = gql`mutation createBreakingNew($input:CreateBreakingNewInput!) {
            createBreakingNew(input:$input) {
                 breakingNew {
                      breakingNewsId
                  newsMessage
                  isActiveYn
                  isDeletedYn
                  createdAt
                  updateAt
                }
              }
            }`;

    this.GET_BREAKING_NEWS = gql`
            query listBreakingNew($offset:Int,$limit:Int) {
              allBreakingNews(filter:{isDeletedYn:{equalTo: false}},offset:$offset,first:$limit) {
                nodes {
                  breakingNewsId
                  newsMessage
                  isActiveYn
                  isDeletedYn
                  createdAt
                  updateAt
                }
                totalCount
              }
            }

            `;

    this.UPDATE_BREAKING_NEW = gql`
            mutation updateBreakingNew($input:UpdateBreakingNewByBreakingNewsIdInput!) {
              updateBreakingNewByBreakingNewsId(input:$input) {
                   breakingNew{
                   breakingNewsId
                    newsMessage
                    isActiveYn
                    isDeletedYn
                    createdAt
                    updateAt
                  }
                }
              }
            `;

    this.UPDATE_LOGO_URL = gql`mutation updateFirms($input: UpdateFirmByFirmIdInput!){
              updateFirmByFirmId(input:$input){
                firm{
                  nodeId
                }
              }
            } `;

  }

  // Uplaod new products
  ADD_PRODUCTS(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_PRODUCT,
      variables: {
        "input": {
          "product": formValue
        }
      },
    })
  }


  // GET all products
  GET_PRODUCTS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_PRODUCTs,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  // GET all products
  List_Order_By_Markets(payload) {
    return this.apollo.watchQuery({
      query: this.LIST_ORDER_BY_MARKETS_FIRMS_OFFICES,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  //update all products
  UPDATE_PRODUCTS(productId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_PRODUCT,
      variables: {
        "input": {
          "productId": productId,
          "productPatch": formValue
        }
      }
    })
  }

  //Delete all products
  DELETE_PRODUCTS(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_PRODUCT,
      variables: {
        "input": formValue
      }
    })
  }

  // Uplaod new market
  ADD_MARKET(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_MARKET,
      variables: {
        "input": {
          "market": formValue
        }
      },
    })
  }


  // GET all market
  GET_MARKETS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_MARKET,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  //update all market
  UPDATE_MARKETS(marketId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_MARKET,
      variables: {
        "input": {
          "marketId": marketId,
          "marketPatch": formValue
        }
      }
    })
  }

  //Delete all market
  DELETE_MARKETS(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_MARKET,
      variables: {
        "input": formValue
      }
    })
  }

  // Uplaod new firm
  ADD_FIRM(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_FIRM,
      variables: {
        "input": {
          "firm": {
            "firmsName": formValue.firmName,
            "logoUrl": formValue.logoUrl
          }
        }
      },
    })
  }

  // Uplaod new office
  UPDATE_LOGOURL(formValue) {
    console.log("formValue", formValue)
    return this.apollo.mutate({
      mutation: this.UPDATE_LOGO_URL,
      variables: {
        "input": {
          "firmId": formValue.firmId,
          "firmPatch": {
            'logoUrl': formValue.logoUrl
          }
        }
      },
    })
  }

  // GET all firm
  GET_FIRMS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_FIRM,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  //Delete all firm
  DELETE_FIRMS(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_FIRM,
      variables: {
        "input": formValue
      }
    })
  }

  //update all market
  UPDATE_FIRMS(firmId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_FIRM,
      variables: {
        "input": {
          "firmId": firmId,
          "firmPatch": formValue
        }
      }
    })
  }

  // Uplaod new office
  ADD_OFFICE(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_OFFICE,
      variables: {
        "input": {
          "office": {
            "officesName": formValue.officeName,
            "firmId": formValue.firmId
          }
        }
      },
    })
  }

  // GET all office
  GET_OFFICES(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_OFFICE,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  // GET all office
  GET_STATUS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_STATUS,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  //Delete all firm
  DELETE_OFFICES(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_OFFICE,
      variables: {
        "input": formValue
      }
    })
  }

  //update all office
  UPDATE_OFFICES(officeId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_OFFICE,
      variables: {
        "input": {
          "officeId": officeId,
          "officePatch": formValue
        }
      }
    })
  }

  UPDATE_STATUS(statusId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_STATUSES,
      variables: {
        "input": {
          "statusId": statusId,
          "statusPatch": formValue
        }
      }
    })
  }

  // Uplaod new coupon
  ADD_COUPON(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_COUPON,
      variables: {
        "input": {
          "coupon": {
            "couponCode": formValue.couponCode,
            "couponDesc": formValue.couponDesc,
            "couponAmount": formValue.couponAmount,
            "totalLimit": formValue.totalLimit,
            "usageLimit": formValue.usageLimit,
            "expireDate": formValue.expireDate,
          }
        }
      },
    })
  }

  // GET all coupons
  GET_COUPONS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_COUPONS,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  //Delete all coupons
  DELETE_COUPONS(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_COUPON,
      variables: {
        "input": formValue
      }
    })
  }

  //update all coupons
  UPDATE_COUPONS(couponId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_COUPON,
      variables: {
        "input": {
          "couponId": couponId,
          "couponPatch": formValue
        }
      }
    })
  }

  // GET all roles
  GET_ROLES(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_ROLES,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  // Add new role
  ADD_ROLE(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_ROLE,
      variables: {
        "input": {
          "role": {
            "roleName": formValue.roleName,
            "roleId": formValue.roleId,
            "roleDescription": formValue.roleDescription,
            "roleDiv": true,
          }
        }
      },
    })
  }

  ADD_STATUS(payload) {
    return this.apollo.mutate({
      mutation: this.CREATE_STATUS,
      variables: {
        "input": {
          "status": payload
        }
      },
    })
  }

  // Uplaod multi market
  ADD_MARKET_MULTI_FIRMS(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_MARKETS_MULTI_FIRMS,
      variables: {
        "input": {
          "marketsMultiFirm": formValue
        }
      },
    })
  }

  // Uplaod multi market
  EDIT_MARKET_MULTI_FIRMS(inputId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_MARKETS_MULTI_FIRMS,
      variables: {
        "input": {
          "marketsMultiFirmsId": inputId,
          "marketsMultiFirmPatch": formValue
        }
      },
    })
  }

  // Uplaod multi firms
  ADD_FIRMS_MULTI_OFFICES(formValue) {
    return this.apollo.mutate({
      mutation: this.CREATE_FIRMS_MULTI_OFFICES,
      variables: {
        "input": {
          "firmsMultiOffice": formValue
        }
      },
    })
  }

  // Uplaod multi office
  EDIT_FIRMS_MULTI_OFFICES(inputId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_FIRMS_MULTI_OFFICES,
      variables: {
        "input": {
          "firmsMultiOfficesId": inputId,
          "firmsMultiOfficePatch": formValue
        }
      },
    })
  }

  //Delete all roles
  DELETE_ROLES(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_ROLE,
      variables: {
        "input": formValue
      }
    })
  }
  //Delete all market multi
  DELETE_MARKETS_MULTI(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_MARKETS_MULTI_FIRMS,
      variables: {
        "input": formValue
      }
    })
  }

  //Delete all firms multi
  DELETE_FIRMS_MULTI(formValue) {
    return this.apollo.mutate({
      mutation: this.DELETE_FIRMS_MULTI_OFFICES,
      variables: {
        "input": formValue
      }
    })
  }

  //update all role
  UPDATE_ROLES(roleId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ROLE,
      variables: {
        "input": {
          "roleId": roleId,
          "rolePatch": formValue
        }
      }
    })
  }

  // Get market based firm list
  GET_MARKET_FIRMS(marketId) {
    return this.apollo.watchQuery({
      query: this.GET_MARKET_FIRM,
      variables: {
        "marketId": marketId
      },
      fetchPolicy: 'network-only'
    })
  }

  // Get firm based office list
  GET_FIRM_OFFICES(marketId, firmId) {
    return this.apollo.watchQuery({
      query: this.GET_FIRM_OFFICE,
      variables: {
        "marketId": marketId,
        "firmId": firmId
      },
      fetchPolicy: 'network-only'
    })
  }

  // Get market based firm check list
  GET_MARKET_FIRMS_CHECK(marketId, firmId) {
    return this.apollo.watchQuery({
      query: this.CHECK_MARKETS_MULTI_FIRMS,
      variables: {
        "marketId": marketId,
        "firmId": firmId
      },
      fetchPolicy: 'network-only'
    })
  }

  // Get firm based office check list
  GET_FIRM_OFFICES_CHECK(marketId, firmId, officeId) {
    return this.apollo.watchQuery({
      query: this.CHECK_FIRMS_MULTI_OFFICES,
      variables: {
        "marketId": marketId,
        "firmId": firmId,
        "officeId": officeId
      },
      fetchPolicy: 'network-only'
    })
  }

  // GET all market
  GET_MARKET() {
    return this.apollo.watchQuery({
      query: this.GET_MARKET_ALL,
      fetchPolicy: 'network-only'
    })
  }

  // GET all market
  GET_ORDER_BY_MARKETS(marketId) {
    return this.apollo.watchQuery({
      query: this.GET_ORDER_BY_MARKET,
      variables: {
        "marketId": marketId
      },
      fetchPolicy: 'network-only'
    })
  }

  // GET market BY NAME
  GET_MARKETS_BY_NAME(marketName) {
    return this.apollo.watchQuery({
      query: this.GET_MARKET_BY_NAME,
      variables: {
        "marketName": marketName
      },
      fetchPolicy: 'network-only'
    })
  }
  // GET FIRMS BY BAME
  GET_FIRMS_BY_NAME(firmsName) {
    return this.apollo.watchQuery({
      query: this.GET_FIRM_BY_NAME,
      variables: {
        "firmsName": firmsName
      },
      fetchPolicy: 'network-only'
    })
  }

  // GET OFFICES BY NAME
  GET_OFFICES_BY_NAME(officesName) {
    return this.apollo.watchQuery({
      query: this.GET_OFFICE_BY_NAME,
      variables: {
        "officesName": officesName
      },
      fetchPolicy: 'network-only'
    })
  }

  // GET all firm
  GET_ALL_MARKET_LIMIT_OFFSET(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_MARKET_LIMIT,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }
  GET_MAIL_TYPES(payload) {
    return this.apollo.watchQuery({
      query: this.GET_MAIL_TYPE,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  ADD_MAIL_TYPES(payload) {
    return this.apollo.mutate({
      mutation: this.ADD_MAIL_TYPE,
      variables: {
        "input": {
          "emailType": payload
        }
      },
    })
  }

  UPDATE_EMAIL_TYPES(emailTypeId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_EMAIL_TYPE,
      variables: {
        "input": {
          "emailTypeId": emailTypeId,
          "emailTypePatch": formValue
        }
      }
    })
  }

  GET_MAIL_TYPE_CONTENTS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_MAIL_TYPE_CONTENT,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  ADD_MAIL_TYPE_CONTENTS(payload) {
    return this.apollo.mutate({
      mutation: this.ADD_MAIL_TYPE_CONTENT,
      variables: {
        "input": {
          "emailTypeContent": payload
        }
      },
    })
  }

  GET_MAIL_TYPE_DROP_DOWN_LIST() {
    return this.apollo.watchQuery({
      query: this.GET_MAIL_TYPE_DROP_DOWN,
      fetchPolicy: 'network-only'
    })
  }

  UPDATE_EMAIL_TYPE_CONTENTS(emailTypeContentId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_EMAIL_TYPE_CONTENT,
      variables: {
        "input": {
          "emailTypeContentId": emailTypeContentId,
          "emailTypeContentPatch": formValue
        }
      }
    })
  }

  ADD_BREAKING_NEWS(payload) {
    return this.apollo.mutate({
      mutation: this.ADD_BREAKING_NEW,
      variables: {
        "input": {
          "breakingNew": payload
        }
      },
    })
  }

  // GET all breaking news
  GET_ALL_BREAKING_NEWS(payload) {
    return this.apollo.watchQuery({
      query: this.GET_BREAKING_NEWS,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  UPDATE_BREAKING_NEWS(breakingNewsId, formValue) {
    return this.apollo.mutate({
      mutation: this.UPDATE_BREAKING_NEW,
      variables: {
        "input": {
          "breakingNewsId": breakingNewsId,
          "breakingNewPatch": formValue
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/configuration.ts